import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {EvidFunctionsService} from '@catmodules/models/evid-functions/services/evid-functions.service';
import {FeatureEvidFunctionsService} from '@catmodules/models/feature-evid-functions/services/feature-evid-functions.service';
import {FeatureEvidFunction, FeatureEvidFunctionCreateInfo} from '@catmodules/models/feature-evid-functions/types';
import {SelectItem} from 'primeng/primeng';
import 'rxjs/add/observable/of';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';
import {sortByLabelFunc} from "@catcore/utils";

/**
 * A component to fast create a new  for the currently used Feature
 *
 */
@Component({
  templateUrl: './feature-evid-functions-welcome.component.html',
})
export class FeatureEvidFunctionsWelcomeComponent extends BaseFeatureWelcomeComponent {

  evidFunctionOptions: SelectItem[];

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfLabel = 'Feature Evid Function';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfLabel}`;

  /**
   * Label names to be used by form input elements.
   *
   * @type {{evidFunctions: string; dropdownPlaceholder: string; buttons: {last: string}}}
   */
  labels = {
    evidFunctions: 'Evid Function',
    dropdownPlaceholder: 'Select one',
    trigger: 'Trigger',
    buttons: {last: `Save the ${this.selfLabel}`},
  };

  featureEvidFunction: FeatureEvidFunction;

  resetAfterComplete = true;

  /**
   * Returns true if the current form object is ready.
   * Ready means all necessary data that is required to display and use the form, is available
   * @returns {boolean}
   */
  get formIsReady() {
    let isReady = !isNullOrUndefined(this.feature);
    isReady = isReady && !isNullOrUndefined(this.evidFunctionOptions);
    return isReady;
  }

  constructor(private evidFunctionsService: EvidFunctionsService,
              private featureEvidFunctionsService: FeatureEvidFunctionsService,
              private featureEvidFunctionService: FeatureEvidFunctionsService,
              private formBuilder: FormBuilder,
              featureService: FeatureTypeService) {

    super(featureService);

    this.form = new FormGroup({
      evidFunction: new FormControl('', [Validators.required])
    });
  }

  validatePropertiesView() {
  }

  /**
   * Creates a new FeatureEvidFunction.
   */
  saveNewEntity() {
    const createInfo: FeatureEvidFunctionCreateInfo = {
      feature: this.feature,
      evidFunction: this.form.value.evidFunction,
    };

    this.featureEvidFunctionsService
      .create(createInfo)
      .flatMap((value) => {
        this.createdEntity = value;
        return Observable.of(value);
      })
      .subscribe((featureEvidFunction) => {
        this.isCompleted = featureEvidFunction !== null;
        this
          .getFeatureService()
          .refreshCurrent();
      });
  }

  beforeDisplayProperties() {
    this
      .evidFunctionsService
      .getAll()
      .subscribe((evidFunctions) => {
        this.updateEvidFunctionOptions(evidFunctions);
      });

    this
      .featureEvidFunctionService
      .getCurrent()
      .subscribe((featureEvidFunction: FeatureEvidFunction) => this.featureEvidFunction = featureEvidFunction);

  }

  private updateEvidFunctionOptions(evidFunctions) {
    const itemList = [];
    evidFunctions.forEach((item) => {
      itemList.push({label: item.name, value: item});
    });
    itemList.sort(sortByLabelFunc);
    this.evidFunctionOptions = itemList;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/feature-evid-functions/components/feature-evid-functions-welcome/feature-evid-functions-welcome.component.ts